module.exports = __webpack_public_path__ + "img/queue-sharing-platform.2337dac1.png";